import React from 'react';
import { motion } from 'framer-motion';
interface StepIndicatorProps {
  currentStepIndex: number;
  totalSteps: number;
  currentStepName: string;
}
const STEP_LABELS: Record<string, string> = {
  welcome: 'Welcome',
  cash: 'Cash',
  investments: 'Investments',
  retirement: 'Retirement',
  goldSilver: 'Gold & Silver',
  moneyOwedToMe: 'Money Owed to Me',
  business: 'Business Assets',
  debts: 'Debts',
  email: 'Your Report',
  summary: 'Summary'
};
export function StepIndicator({
  currentStepIndex,
  totalSteps,
  currentStepName
}: StepIndicatorProps) {
  const progress = (currentStepIndex + 1) / totalSteps * 100;
  const label = STEP_LABELS[currentStepName] || currentStepName.replace(/([A-Z])/g, ' $1').trim();
  return <div className="mb-8" data-id="element-261">
      <div className="flex justify-between items-end mb-2" data-id="element-262">
        <div data-id="element-263">
          <span className="text-xs font-semibold text-teal-600 uppercase tracking-wider" data-id="element-264">
            Step {currentStepIndex + 1} of {totalSteps}
          </span>
          <h2 className="text-lg font-bold text-gray-900 mt-1" data-id="element-265">{label}</h2>
        </div>
        <span className="text-sm font-medium text-gray-500" data-id="element-266">
          {Math.round(progress)}%
        </span>
      </div>
      <div className="h-2 w-full bg-gray-100 rounded-full overflow-hidden" data-id="element-267">
        <motion.div className="h-full bg-[#2D9596]" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-268" />
      </div>
    </div>;
}